const CHIAVI_SESSIONE = {
  CHIAVE_ROTTA_DOPO_ACCESSO: 'chiaveRottaDopoAccesso',
  CHIAVE_ROTTA_HOME_SERVIZIO: 'chiaveRottaHomeServizio',
  CHIAVE_UUID_ROOM: 'chiaveUuidRoom'
}

export {
  CHIAVI_SESSIONE
}